module.exports = __webpack_public_path__ + "static/medicalreel_jm-b00f5fe0a0e65a2d53ee592ef64dcf28.mp4";